import React from "react";
import HappySchoolDataTable from "./HappySchoolDataTable";

// Bảng "Vi phạm" — nhà trường nhập tay, GV chỉ xem được đúng dòng khớp tên
// hồ sơ của mình (qua tab "Vi phạm" trong "Xem thu nhập"). Chức năng riêng,
// ngang hàng với "Xếp thời khoá biểu" (trước đây nằm lồng trong đó).
const VIPHAM_TABLE_KEY = "viphamGV";
const VIPHAM_CFG = {
  title: "Vi phạm — GV Văn hoá",
  columns: [
    { key: "stt", label: "STT", width: 50 },
    { key: "hoten", label: "Họ và tên", width: 180 },
    { key: "ngay", label: "Ngày", width: 110 },
    { key: "noidung", label: "Nội dung vi phạm", width: 260 },
    { key: "sotientru", label: "Số tiền trừ", width: 120 },
    { key: "trangthai", label: "Trạng thái xử lý", width: 130 },
    { key: "ghichu", label: "Ghi chú", width: 200 },
  ],
  totalColumns: ["sotientru"],
  publishable: true,
};

const HappySchoolViPhamGV = () => (
  <div>
    <h3 style={{ margin: "0 0 12px" }}>
      ⚠️ Vi phạm — GV Văn hoá{" "}
      <span style={{ fontWeight: 400, color: "#6b7280", fontSize: 14 }}>(GV chỉ xem đúng dòng khớp tên mình, ở tab "Vi phạm" trong "Xem thu nhập")</span>
    </h3>
    <HappySchoolDataTable tableKey={VIPHAM_TABLE_KEY} config={VIPHAM_CFG} />
  </div>
);

export default HappySchoolViPhamGV;
